module.exports = __webpack_public_path__ + "static/hgf-1eb1c38ed6d93aa532899412d41cbe02.png";